<script>
  import Container from '~/components/ui/container.svelte'
  import LinkButton from '~/components/ui/link-button.svelte'
  import AboutBusinessList from '../../module_about/components/_business-list.svelte'
</script>

<section class="section | mb-[128px]">
  <Container>
    <h2 class="title | mb-4 text-center text-4xl font-medium md:text-5xl">Sobre a Lutruvials</h2>

    <p class="description | mx-auto mb-4 w-full text-center lg:w-[60%]">
      Somos uma empresa de desenvolvimento de sites e soluções digitais sob medida. Contamos com
      nossa equipe dedicada e apaixonada por transformar ideias em sistemas eficientes, escaláveis e
      de alto desempenho.
    </p>

    <AboutBusinessList />

    <LinkButton
      colorPalette="brand"
      variant="solid"
      class="mx-auto mb-8 block w-6/12 text-center text-sm md:w-8/12 md:text-lg lg:w-3/12"
      href="/sobre"
    >
      Saiba mais...
    </LinkButton>
  </Container>
</section>
